// Logos
import collxLogo from '@/assets/images/logos/collx.svg'
import ebayLogo from '@/assets/images/logos/ebay.svg'
import authEbayLogo from '@/assets/images/auth-ebay.svg'
import shopifyLogo from '@/assets/images/logos/shopify.svg'
import whatnotLogo from '@/assets/images/logos/whatnot.svg'
import whatnotLogoMini from '@/assets/images/logos/whatnot-yellow-mini.svg'
import collxLogoMini from '@/assets/images/logos/collx-mini.svg'

import collxLogoMiniAlt from '@/assets/images/logos/collx-mini-alt.svg'
import ebayLogoMiniAlt from '@/assets/images/logos/ebay-mini-alt.svg'
import shopifyLogoMiniAlt from '@/assets/images/logos/shopify-mini-alt.svg'
import whatnotLogoMiniAlt from '@/assets/images/logos/whatnot-mini-alt.svg'

import ebayLogoMini from '@/assets/images/logos/ebay-mini.svg'
import shopifyLogoMini from '@/assets/images/logos/shopify-mini.svg'
import simpleAuctionLogo from '@/assets/images/logos/simple-auction.svg'
import moment from 'moment'

export const TABS = [
  { text: 'Overview', route: '/connections/ebay', key: 'overview' },
  { text: 'eBay Settings', route: '/connections/ebay/connection-settings', key: 'connection_settings' },
  { text: 'My Locations', route: '/connections/ebay/my-locations', key: 'my_locations' },
  { text: 'CSV Export Templates', route: '/connections/ebay/templates', key: 'templates'},
  { text: 'Marketplace Templates', route: '/connections/ebay/marketplace-templates', key: 'marketplace_templates'},
  { text: 'History', route: '/connections/ebay/history/export', key: 'history' },
]

export const COLLX_CONNECTION_TABS = [
  { text: 'Overview', route: '/connections/collx', key: 'overview' },
  // { text: 'Listing Information', route: '/connections/collx/listing-information', key: 'listing_information' },
  { text: 'CollX Settings', route: '/connections/collx/connection-settings', key: 'connection_settings' },
  { text: 'History', route: '/connections/collx/history/export', key: 'export_history' },
]

export const SHOPIFY_CONNECTION_TABS = [
  { text: 'Overview', route: '/connections/shopify', key: 'overview' },
  { text: 'Connection Settings', route: '/connections/shopify/export-settings', key: 'export_settings'},
  { text: 'History', route: '/connections/shopify/history/export', key: 'export_history' },
]

export const WHATNOT_CONNECTION_TABS = [
  { text: 'Overview', route: '/connections/whatnot' },
  { text: 'Whatnot Settings', route: '/connections/whatnot/connection-settings', key: 'connection_settings' },
  { text: 'Marketplace Templates', route: '/connections/whatnot/marketplace-templates', key: 'marketplace_templates'},
  { text: 'History', route: '/connections/whatnot/history/export', key: 'export_history' },
]

export const LISTING_PRICES = ['Standard Price', 'Calculated Price', 'Price Override']

export const COLLX_LISTING_PRICES = ['Sale Price', 'Calculated Price', 'Price Override']

export const INCREASE_OPTIONS = ['Fixed Amount', 'Percentage']

export const SHIPPING_SERVICES = [
  {
    headerName: 'Economy',
    options: ['eBay Standard Envelope', 'Economy Shipping'],
  },
  {
    headerName: 'Standard',
    options: [
      'USPS Standard Post',
      'USPS Priority Mail',
      'USPS Ground Advantage',
      'FedEx Ground',
    ],
  },
  {
    headerName: 'Expedited',
    options: ['FedEx Express Saver', 'FedEx 2day', 'UPS 2 Day', 'UPS 3 Day'],
  },
  {
    headerName: 'One-Day services',
    options: ['FedEx Overnight', 'UPS Next Day'],
  },
]

export const HANDLING_TIME = [
  {
    headerName: 'Regular',
    options: {
      0: 'Same Business Day',
      1: '1 day',
      2: '2 days',
      3: '3 days',
    },
  },
  {
    headerName: 'Extended',
    options: {
      4: '4 days',
      5: '5 days',
      10: '10 days',
      15: '15 days',
      20: '20 days',
      30: '30 days',
    },
  },
]

export const HANDLING_TIME_VALUES = {
  0: 'Same Business Day',
  1: '1 day',
  2: '2 days',
  3: '3 days',
  4: '4 days',
  5: '5 days',
  10: '10 days',
  15: '15 days',
  20: '20 days',
  30: '30 days',
}

export const FORM_CONNECTION_OPTIONS = [
  {
    label: 'Within',
    placeholder: 'Please select',
    field: 'returns_within',
    options: {
      14: '14 Days',
      30: '30 Days',
      60: '60 Days',
    },
  },
  {
    label: 'Refund',
    placeholder: 'Please select',
    field: 'refund_given_as',
    options: {
      'Money Back': 'Money Back',
      'Money Back or Replacement (Buyers Choice)': 'Money Back or Replacement (Buyers Choice)',
      'Money Back or Replacement (Sellers Choice)': 'Money Back or Replacement (Sellers Choice)',
    },
  },
  {
    label: 'Shipping Cost Paid By',
    placeholder: 'Please select',
    field: 'return_shipping_paid_by',
    tooltip: `
      Tip: To use this feature, you first need to enable eBay’s Return Process on eBay by going to <br/>
      My eBay > Account > Site Preferences > Return Preferences,
      and then setting ‘Do you want to use eBay’s return process?’ to Yes.
    `,
    options: {
      Buyer: 'Buyer',
      Seller: 'Seller',
    },
  },
]

export const FORM_CONNECTION_OPTIONS_VALUES = {
  14: '14 Days',
  30: '30 Days',
  60: '60 Days',
  'Money Back': 'Money Back',
  'Money Back or Replacement (Buyers Choice)': 'Money Back or Replacement (Buyers Choice)',
  'Money Back or Replacement (Sellers Choice)': 'Money Back or Replacement (Sellers Choice)',
  Buyer: 'Buyer',
  Seller: 'Seller',
}

export const DEFAULT_TEMPLATE = {
  id: null,
  user_id: null,
  name: '',
  type: 'ebay',
  listing_type: 'fixed',
  listing_price: true,
  fixed_amount_to_price: 0,
  percent_to_price: 0,
  allow_best_offer: false,
  duration: 'GTC',
  handling_time: null,
  shipping_service: '',
  free_shipping: false,
  shipping_cost: 0,
  additional_items: 0,
  returns: true,
  returns_within: null,
  refund_given_as: '',
  return_shipping_paid_by: '',
  additional_return_info: '',
  default: false,
  auto_accept_offer: false,
  auto_decline_offer: false,
  calculated_method: true,
  enable_buy_it_now_price: true,
  start_price: 0,
  buy_it_now_price: 0,
  ebay_category: 261328,
  store_category: 0,
  city: '',
  state: '',
  zip_code: '',
  return_profile_name: '',
  shipping_profile_name: '',
  immediate_payment: false,
  created_at: null,
  updated_at: null,
  deleted_at: null,
  make_live_immediately: true,
  schedule_date: moment().format('YYYY-MM-DD'),
  schedule_time: moment().format('hh:mm:ss'),
  set_for_all: true,
  schedule_interval: 'Seconds',
  schedule_delay: 0,
  price_adjustment_type: 'increase',
  // eBay rejects Buy It Now under $0.99, which pushed dealers to
  // overprice everywhere else just to clear that floor. With this on, the card
  // keeps its TRUE sale price and only the price sent to eBay is lifted to
  // $0.99 — CollX, Shopify and Whatnot still get the real one.
  //
  // The backend owns the lift itself (it happens on send); this flag is the
  // template setting it reads.
  round_up_sale_price_to_dollar: false,
  use_cert_as_sku: false,
  make_live_immediately: true,
  whatnot_sudden_death: false,
  whatnot_listing_action: 'publish',
  whatnot_accept_offers: false,
  whatnot_hazardous: 0
}

export const EBAY_CATEGORIES = {
  261328: 'Sports Trading Cards - Trading Card Singles (#261328)',
  183454: 'Collectible Card Games - Trading Card Singles (#183454)',
  183050: 'Non-Sports Trading Cards - Trading Card Singles (#183050)',
}
export const EBAY_CATEGORIES_LABELS_FOR_ERRORS_BEFORE_LISTING = {
  261328: {
    label: 'Sports Trading Cards',
    tcg: 'Collectible Card Games',
    nonsport: 'Non-Sports Trading Cards',
  },

  183454: {
    label: 'Collectible Card Games',
    sports: 'Sports Trading Cards',
    nonsport: 'Non-Sports Trading Cards',
  },
  183050: {
    label: 'Non-Sports Trading Cards',
    sports: 'Sports Trading Cards',
    tcg: 'Collectible Card Games',
  },
}

export const EBAY_TYPES_BY_CATEGORIES = {
  261328: 'sports',
  183454: 'tcg',
  183050: 'nonsport',
}

export const WHATNOT_CATEGORIES = {
  'Trading Card Games': {
    5597: 'Trading Card Games',
    5598: 'Pokémon Cards', 
    5599: 'Magic: The Gathering',
    5600: 'Yu-Gi-Oh! Cards',
    5601: 'One Piece Cards',
    5602: 'Disney Cards',
    5603: 'Weiß Schwarz',
    5604: 'Dragon Ball Cards',
    5605: 'Naruto Cards',
    5606: 'Star Wars Cards',
    5607: 'Marvel Cards',
    5608: 'DC Cards',
    5609: 'Digimon Cards',
    5610: 'My Hero Academia Cards',
    5611: 'Flesh & Blood',
    5612: 'MetaZoo',
    5613: 'Kryptik',
    5614: 'Akora',
    5615: 'Garbage Pail Kids',
    5616: 'TCG Accessories',
    5617: 'Kickstarter'
  },
  'Sports Cards': {
    5618: 'Sports Cards',
    5619: 'Football Cards',
    5620: 'Basketball Cards',
    5621: 'Baseball Cards',
    5622: 'Soccer Cards',
    5623: 'UFC Cards',
    5624: 'Hockey Cards',
    5625: 'Wrestling Cards',
    5626: 'Motorsport Cards'
  }
}

export const CATEGORIES = {
  261328: 'Sports Trading Cards - Trading Card Singles (#261328)',
  183454: 'Collectible Card Games - Trading Card Singles (#183454)',
  183050: 'Non-Sports Trading Cards - Trading Card Singles (#183050)',
}

export const LISTING_DURATION = [ 'GTC' ]
export const LISTING_DURATION_AUCTION = ['7', '10', '5', '3', '1' ]
export const LISTING_DURATION_VIEW = {
  1: '1 day',
  3: '3 days',
  5: '5 days',
  7: '7 days',
  10: '10 days',
  30: '30 days',
  GTC: 'Good Till Canceled (GTC)'
}

export const EBAY_CHANNEL = {
  authLogo: authEbayLogo,
  logo: ebayLogo,
  miniLogo: ebayLogoMini,
  miniLogoAlt: ebayLogoMiniAlt,
  name: 'eBay',
  beta: true,
  full_name: 'eBay Direct Connection',
  label: 'eBay Marketplace',
  key: 'ebay',
  keyField: 'ebay',
  description: 'Increase sales by creating listings that reaching millions of shoppers on eBay',
  infoRoute: '/connections/ebay',
  connected: true,
  url: 'https://www.ebay.com/',
  field: 'ebay_enabled',
  checked: false,
  listedField: 'ebayListedStatus',
  profileName: 'ebay_profile',
  marketplaceTemplatesField: 'marketplaceListingTemplates',
  urlToTemplates: '/connections/ebay/marketplace-templates'
}

export const WHATNOT_CHANNEL = {
  authLogo: whatnotLogo,
  logo: whatnotLogo,
  miniLogo: whatnotLogoMini,
  miniLogoAlt: whatnotLogoMiniAlt,
  name: 'Whatnot',
  full_name: 'Whatnot Listing Connection',
  label: 'Whatnot Marketplace',
  key: 'whatnot',
  keyField: 'whatnot',
  description: 'Increase sales by creating listings that reaching millions of shoppers on Whatnot',
  infoRoute: '/connections/whatnot',
  connected: true,
  url: 'https://www.whatnot.com/',
  field: 'whatnot_enabled',
  checked: false,
  listedField: 'whatnotListedStatus',
  profileName: 'whatnot_profile',
  marketplaceTemplatesField: 'whatnotListingTemplates',
}

export const SHOPIFY_CHANNEL = {
  authLogo: shopifyLogo,
  logo: shopifyLogo,
  miniLogo: shopifyLogoMini,
  miniLogoAlt: shopifyLogoMiniAlt,
  name: 'Shopify',
  full_name: 'Shopify Direct Connection',
  label: 'Shopify',
  key: 'shopify',
  keyField: 'shopify',
  description: 'Sell anywhere with low rates and predictable fees',
  infoRoute: '/connections/shopify',
  connected: true,
  url: 'https://www.shopify.com/',
  field: 'shopify_enabled',
  checked: false,
  listedField: 'shopifyListedStatus',
  profileName: '',
  marketplaceTemplatesField: 'shopifyListingTemplates',
  beta: true
}

export const COLLX_CHANNEL = {
  authLogo: collxLogo,
  logo: collxLogo,
  miniLogo: collxLogoMini,
  miniLogoAlt: collxLogoMiniAlt,
  name: 'CollX',
  full_name: 'CollX Direct Connection',
  label: 'CollX Marketplace',
  key: 'collx',
  keyField: 'collx',
  description: 'The fastest growing marketplace for trading cards',
  infoRoute: '/connections/collx',
  connected: true,
  url: 'https://www.collx.app/',
  field: 'collx_enabled',
  checked: false,
  listedField: 'collxListedStatus',
  profileName: '',
  marketplaceTemplatesField: 'collxListingTemplates',
  urlToTemplates: '/connections/collx/listing-information'
}

export const SIMPLE_AUCTION_CHANNEL = {
  logo: simpleAuctionLogo,
  name: 'Simple Auction',
  description: 'Increase sales by creating listings that reaching millions of shoppers on eBay',
  infoRoute: '/connections/simple-auction',
  connected: true,
  url: 'https://simpleauctionsite.com/',
  field: 'simple_auction_enabled',
  checked: false
}

export const RECOMMENDED_CONNECTION_CHANNELS = [
  { ...COLLX_CHANNEL },
  { ...EBAY_CHANNEL },
  { ...WHATNOT_CHANNEL },
  { ...SHOPIFY_CHANNEL },
  // { ...SIMPLE_AUCTION_CHANNEL }
]

export const ALL_CONNECTION_CHANNELS = [
  { ...COLLX_CHANNEL },
  { ...EBAY_CHANNEL },
  { ...WHATNOT_CHANNEL },
  { ...SHOPIFY_CHANNEL },
  // { ...SIMPLE_AUCTION_CHANNEL }
]

export const PUSHER_EVENTS_TO_CHANNELS = {
  collx_import_completed: { name: 'CollX', channel: COLLX_CHANNEL },
  ebay_import_completed: { name: 'eBay', channel: EBAY_CHANNEL },
  shopify_import_completed: { name: 'Shopify', channel: SHOPIFY_CHANNEL },
  ebay_import_failed: { name: 'eBay', channel: EBAY_CHANNEL },
  whatnot_import_completed: { name: 'Whatnot', channel: WHATNOT_CHANNEL },
  collx_listing_completed: { name: 'CollX', channel: COLLX_CHANNEL }
}

export const CHANNELS_BY_TYPE = {
  collx: { name: 'CollX', channel: COLLX_CHANNEL },
  ebay: { name: 'eBay', channel: EBAY_CHANNEL },
  'ebay-direct': { name: 'eBay', channel: EBAY_CHANNEL },
  whatnot: { name: 'Whatnot', channel: WHATNOT_CHANNEL },
  shopify: { name: 'Shopify', channel: SHOPIFY_CHANNEL },
  'shopify-direct': { name: 'Shopify', channel: SHOPIFY_CHANNEL }
}

export const NOTIFICATIONS_PREVIEW_MESSAGES = {
  imports_finished: {
    label: 'Import',
    message: (count) => `${count} items imported`,
  },
  sales: {
    label: 'Sales',
    message: (count, channelName) => `You sold ${count} items on ${channelName} today`,
  },
  sends_completed: {
    label: 'Export',
    message: (count, channelName) => `${count} items exported to ${channelName}`,
  },
}

export const NOTIFICATION_TYPES = {
  'sale.recorded:ebay': {},
  'sale.recorded:collx': {},
  'sale.recorded:whatnot': {},
  'sale.recorded:shopify': {},
  
  'import.finished:ebay': {
    buttonLabel: 'View Import',
    link: '/connections/ebay/history/import',
  },
  'import.finished:collx': {
    buttonLabel: 'View Import',
    link: '/connections/collx/history/import',
  },
  'import.finished:whatnot': {
    buttonLabel: 'View Import',
    link: '/connections/whatnot/history/import',
  },

  'export:ebay': {
    buttonLabel: 'View Export',
    link: '/connections/ebay/history/export',
  },
  'export:collx': {
    buttonLabel: 'View Export',
    link: '/connections/collx/history/export',
  },
  'export:whatnot': {
    buttonLabel: 'View Export',
    link: '/connections/whatnot/history/export',
  },
  'export:shopify': {
    buttonLabel: 'View Export',
    link: '/connections/shopify/history/export',
  },
}



export const EBAY_CONNECTION_STEPS = [
  { text: 'Connect eBay Account', route: '/connections', checked: false, routeLabel: 'connect' },
  { text: 'Marketplace Listing', route: '/connections', checked: false, routeLabel: 'marketplace-listing-information' },
  { text: 'Select eBay Policies', route: '/connections', checked: false, routeLabel: 'policies' },
]

export const WHATNOT_CONNECTION_STEPS = [
  { text: 'Connect Whatnot Account', route: '/connections', checked: false, routeLabel: 'connect' },
  { text: 'Listing Information', route: '/connections', checked: false, routeLabel: 'listing-information' },
  { text: 'Select Whatnot Profile', route: '/connections', checked: false, routeLabel: 'profile' },
]

export const COLLX_CONNECTION_STEPS = [
  { text: 'Connect CollX Account', route: '/connections', checked: false, routeLabel: 'account-connection' },
  { text: 'CollX Listing Information', route: '/connections', checked: false, routeLabel: 'listing-information' },
]

export const SHOPIFY_CONNECTION_STEPS = [
  { text: 'Connect Shopify Store', route: '/connections', checked: false, routeLabel: 'connect' },
  { text: 'Listing Settings', route: '/connections', checked: false, routeLabel: 'listing-information' },
]

export const CONNECTION_STEPS = {
  ebay: EBAY_CONNECTION_STEPS,
  whatnot: WHATNOT_CONNECTION_STEPS,
  collx: COLLX_CONNECTION_STEPS,
  shopify: SHOPIFY_CONNECTION_STEPS,
}

export const EXPORT_CONNECTION_STEPS = [
  { text: 'eBay Listing Information', route: '/connections', checked: false, routeLabel: 'listing-information' },
  { text: 'eBay Shipping Settings', route: '/connections', checked: false, routeLabel: 'shipping-settings' },
  { text: 'eBay Payment & Return Settings', route: '/connections', checked: false, routeLabel: 'payment-return-settings' },
]

export const COLLX_CDP_COMPARISON_TABLE = [
  { collx_key: 'CollX', cdp_key: 'Card dealer pro' },
  { collx_key: 'Product Type', cdp_key: 'Type' },
  { collx_key: 'Sport / Game', cdp_key: 'Category' },
  { collx_key: 'Graded', cdp_key: 'Graded' },
  { collx_key: 'Grader', cdp_key: 'Grader' },
  { collx_key: 'Cert No.', cdp_key: 'Certificate No.' },
  { collx_key: 'Condition', cdp_key: 'Condition' },
  { collx_key: 'Purchase Price', cdp_key: 'Purchase Price' },
  { collx_key: 'Purchase Date', cdp_key: 'Purchase Date' },
  { collx_key: 'Name', cdp_key: 'Player Name' },
  { collx_key: 'Set', cdp_key: 'Set' },
  { collx_key: 'Year', cdp_key: 'Year' },
  { collx_key: 'Brand', cdp_key: 'Brand' },
  { collx_key: 'Card Number', cdp_key: 'Card Number' },
  { collx_key: 'Subset / Parallel', cdp_key: 'Subset / Parallel' },
  { collx_key: 'Variation', cdp_key: 'Variation' },
  { collx_key: 'Team', cdp_key: 'Team' },
  { collx_key: 'Attributes', cdp_key: 'Attributes' },
  { collx_key: 'Notes', cdp_key: 'Description' },
]

export const COLLX_LABEL_SIZE = {
  FOUR_BY_SIX: '4" x 6"',
  EIGHT_AND_A_HALF_BY_ELEVEN: '8.5" x 11"'
}

export const POLICIES_IDS_NAMES_IN_TEMPLATE = {
  locations: 'ebay_location_id',
  fulfillmentPolicies: 'ebay_fulfillment_policy_id',
  paymentPolicies: 'ebay_payment_policy_id',
  returnPolicies: 'ebay_return_policy_id',
  shippingProfile: 'ebay_shipping_profile_id',
}

export const POLICIES_IDS_NAMES_IN_POLICY_LIST = {
  locations: 'locationId',
  fulfillmentPolicies: 'fulfillmentPolicyId',
  paymentPolicies: 'paymentPolicyId',
  returnPolicies: 'returnPolicyId'
}

export const HEADER_CONNECTION_AVAILABLE_FOR_STEPS = [
  '/connections/ebay/export/listing-information', 
  '/connections/ebay/connect', 
  '/connections/ebay/policies', 
  '/connections/ebay/marketplace-listing-information', 
  '/connections/ebay/export/shipping-settings', 
  '/connections/ebay/export/payment-return-settings',
  '/connections/whatnot/connect', 
  '/connections/whatnot/listing-information', 
  '/connections/whatnot/profile', 
  '/connections/shopify/connect', 
  '/connections/shopify/listing-information', 
  '/connections/collx/account-connection', 
  '/connections/collx/listing-information', 
]

export const NEW_TEMPLATE_NAMES = {
  ebay: 'New eBay Listing Template',
  whatnot: 'My Whatnot Listing Connection'
}

export const INTERVAL_OPTIONS = [ 'Minutes', 'Seconds' ]

/**
 * The BACKEND's wording for eBay's Buy It Now floor, as it arrives on
 * `card.errors.start_price`. Matched by string because that is the only thing
 * distinguishing it from every other `start_price` error the same field can
 * carry — there is no error code.
 *
 * Named here rather than written out at each site so the two places that test
 * for it can't drift apart. If the backend ever rewords it, this constant is
 * the single edit; until then a mismatch degrades safely (the error simply
 * keeps blocking).
 */
export const EBAY_MIN_PRICE_ERROR =
  'Sale Price: On eBay, the Buy It Now price must be greater than or equal to US $0.99'

/**
 * Copy for the "round up sale price" toggle, per marketplace.
 *
 * The setting is one backend field (`round_up_sale_price_to_dollar`) and one
 * behaviour — keep the card's TRUE price, lift only what this marketplace is
 * sent — but the sentence has to name the marketplace and its own floor, or it
 * reads as a claim about the wrong one. Lives here rather than in the template
 * so adding a third marketplace is a data change.
 *
 * `others` is the list of marketplaces that still receive the real price; it is
 * what makes the promise concrete rather than "kept elsewhere".
 */
export const ROUND_UP_PRICE_COPY = {
  ebay: {
    heading: 'Round Up Prices for eBay',
    label: 'List cards priced under $0.99 on eBay at $0.99',
    tooltip: "eBay won't accept Buy It Now under $0.99. When enabled, CDP sends $0.99 to eBay for anything priced lower and keeps your true price on CollX, Shopify, and Whatnot.",
  },
  whatnot: {
    heading: 'Round Up Prices for Whatnot',
    label: 'List cards priced under $1 on Whatnot at $1',
    tooltip: "Whatnot won't accept listings under $1. When enabled, CDP sends $1 to Whatnot for anything priced lower and keeps your true price on CollX, Shopify, and eBay.",
  },
}

export const ALLOWED_EBAY_TEMPLATE_FIELDS = {
  type: 'listingTemplates',
  connection: 'ebay',
  category: true,
  storeCategory: true,
  label: 'eBay Category Number',
  bestOffer: true,
  duration: true,
  listingSchedule: true,
  sku: true,
  allowedShipping: true,
  allowedPayment: true,
  allowedReturn: true,
  enableBuyItNow: true,
  listingType: true,
}

export const ALLOWED_EBAY_DIRECT_TEMPLATE_FIELDS = {
  type: 'marketplaceListingTemplates',
  connection: 'ebay',
  category: true,
  storeCategory: true,
  label: 'eBay Category Number',
  bestOffer: true,
  duration: true,
  listingSchedule: true,
  sku: true,
  allowedShipping: true,
  allowedPayment: true,
  allowedReturn: true,
  enableBuyItNow: true,
  listingType: true,
  // eBay-only: no other marketplace has a sub-$1 floor to work around, and the
  // CSV export template above never reaches eBay's listing API.
  roundUpPrice: true,
}

export const ALLOWED_WHATNOT_TEMPLATE_FIELDS = {
  type: 'whatnotListingTemplates',
  connection: 'whatnot',
  // Whatnot has its own sub-$1 floor, so it gets the same toggle as eBay.
  roundUpPrice: true,
  category: false,
  label: 'Whatnot Category',
  suddenDeath: true,
  acceptOffer: true,
  publishListing: true,
  time: true,
  shippingInfo: true,
  listingType: true,
}

export const ALLOWED_SHOPIFY_TEMPLATE_FIELDS = {
  type: 'shopifyListingTemplates',
  connection: 'shopify',
  category: false,
  label: 'Shopify Category',
  priceLabel: 'Price format',
}

export const ALLOWED_TEMPLATE_FIELDS_PER_CONNECTION = {
  ebay: ALLOWED_EBAY_TEMPLATE_FIELDS,
  'ebay-direct': ALLOWED_EBAY_DIRECT_TEMPLATE_FIELDS,
  whatnot: ALLOWED_WHATNOT_TEMPLATE_FIELDS,
  shopify: ALLOWED_SHOPIFY_TEMPLATE_FIELDS,
}

export const POLICY_LABELS = [
  {
    type: 'locations',
    label: 'Locations',
    buttonLabel: 'CDP Default Location',
    addButtonLabel1: 'New Location',
    addButtonLabel2: '',
    addLabel: 'Item Location',
    field: 'ebay_location_id'
  },
  {
    type: 'fulfillmentPolicies',
    label: 'Fulfillment Policy',
    buttonLabel: 'CDP Default Fulfillment Policy',
    addButtonLabel1: 'Add Fulfillment Policy',
    addButtonLabel2: 'Enter fulfillment info below',
    addLabel: 'Fulfillment',
    field: 'ebay_fulfillment_policy_id'
  },
  {
    type: 'paymentPolicies',
    label: 'Payment Policy',
    buttonLabel: 'CDP Default Payment Policy',
    addButtonLabel1: 'Add Payment Policy',
    addButtonLabel2: 'Enter payment info below',
    addLabel: 'Payment',
    field: 'ebay_payment_policy_id'
  },
  {
    type: 'returnPolicies',
    label: 'Return Policy',
    buttonLabel: 'CDP Default Return Policy',
    addButtonLabel1: 'Add Return Policy',
    addButtonLabel2: 'Enter return info below',
    addLabel: 'Item Return',
    field: 'ebay_return_policy_id'
  },
  {
    type: 'shippingProfile',
    label: 'Shipping Profile',
    buttonLabel: 'CDP Default Shipping Profile',
    addButtonLabel1: 'Add Return Policy',
    addButtonLabel2: 'Enter return info below',
    addLabel: 'Item Return',
  },
] 

export const EXPORT_CONNECTION_TYPES = {
  'ebay': {
    name: 'CSV Export',
    icon: ebayLogoMini
  },
  'ebay-direct': {
    name: 'Direct Connection',
    icon: ebayLogoMini
  },
  'collx': {
    name: 'CollX',
    icon: collxLogoMini
  },
  'shopify': {
    name: 'CSV Export',
    icon: shopifyLogoMini
  },
  'shopify-direct': {
    name: 'Direct Connection',
    icon: shopifyLogoMini
  },
  'whatnot': {
    name: 'Whatnot',
    icon: whatnotLogoMini
  },
}

export const DEFAULT_LOCATION = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  country: '',
  postalCode: '',
  stateOrProvince: '',
  name: ''
}

export const US_STATES = [
  { abbreviation: "AL", name: "Alabama" },
  { abbreviation: "AK", name: "Alaska" },
  { abbreviation: "AZ", name: "Arizona" },
  { abbreviation: "AR", name: "Arkansas" },
  { abbreviation: "CA", name: "California" },
  { abbreviation: "CO", name: "Colorado" },
  { abbreviation: "CT", name: "Connecticut" },
  { abbreviation: "DE", name: "Delaware" },
  { abbreviation: "DC", name: "District of Columbia" },
  { abbreviation: "DC", name: "Washington" },
  { abbreviation: "FL", name: "Florida" },
  { abbreviation: "GA", name: "Georgia" },
  { abbreviation: "HI", name: "Hawaii" },
  { abbreviation: "ID", name: "Idaho" },
  { abbreviation: "IL", name: "Illinois" },
  { abbreviation: "IN", name: "Indiana" },
  { abbreviation: "IA", name: "Iowa" },
  { abbreviation: "KS", name: "Kansas" },
  { abbreviation: "KY", name: "Kentucky" },
  { abbreviation: "LA", name: "Louisiana" },
  { abbreviation: "ME", name: "Maine" },
  { abbreviation: "MD", name: "Maryland" },
  { abbreviation: "MA", name: "Massachusetts" },
  { abbreviation: "MI", name: "Michigan" },
  { abbreviation: "MN", name: "Minnesota" },
  { abbreviation: "MS", name: "Mississippi" },
  { abbreviation: "MO", name: "Missouri" },
  { abbreviation: "MT", name: "Montana" },
  { abbreviation: "NE", name: "Nebraska" },
  { abbreviation: "NV", name: "Nevada" },
  { abbreviation: "NH", name: "New Hampshire" },
  { abbreviation: "NJ", name: "New Jersey" },
  { abbreviation: "NM", name: "New Mexico" },
  { abbreviation: "NY", name: "New York" },
  { abbreviation: "NC", name: "North Carolina" },
  { abbreviation: "ND", name: "North Dakota" },
  { abbreviation: "OH", name: "Ohio" },
  { abbreviation: "OK", name: "Oklahoma" },
  { abbreviation: "OR", name: "Oregon" },
  { abbreviation: "PA", name: "Pennsylvania" },
  { abbreviation: "RI", name: "Rhode Island" },
  { abbreviation: "SC", name: "South Carolina" },
  { abbreviation: "SD", name: "South Dakota" },
  { abbreviation: "TN", name: "Tennessee" },
  { abbreviation: "TX", name: "Texas" },
  { abbreviation: "UT", name: "Utah" },
  { abbreviation: "VT", name: "Vermont" },
  { abbreviation: "VA", name: "Virginia" },
  { abbreviation: "WA", name: "Washington" },
  { abbreviation: "WV", name: "West Virginia" },
  { abbreviation: "WI", name: "Wisconsin" },
  { abbreviation: "WY", name: "Wyoming" },
  { abbreviation: "PR", name: "Puerto Rico" },
  { abbreviation: "VI", name: "Virgin Islands" },
  { abbreviation: "AS", name: "American Samoa" },
  { abbreviation: "GU", name: "Guam" },
  { abbreviation: "MP", name: "Northern Mariana Islands" },
  { abbreviation: "AA", name: "Armed Forces Americas" },
  { abbreviation: "AE", name: "Armed Forces Europe" },
  { abbreviation: "AP", name: "Armed Forces Pacific" }
]

export const MARKETPLACE_IDS = [
  { id: 'EBAY_US', name: 'United States', isoCode: 'US' },
  { id: 'EBAY_CA', name: 'Canada', isoCode: 'CA' },
  { id: 'EBAY_GB', name: 'United Kingdom', isoCode: 'GB' },
  { id: 'EBAY_AU', name: 'Australia', isoCode: 'AU' },
]

export const SUPPORTED_MARKETPLACE_COUNTRIES = [
  { name: 'United States', isoCode: 'US' },
  { name: 'Canada', isoCode: 'CA' },
  { name: 'United Kingdom', isoCode: 'GB' },
  { name: 'Australia', isoCode: 'AU' },
]

export const ADMIN_DIVISION_TERMS = {
  'State': ['US', 'AU', 'BR', 'IN', 'MX', 'NG', 'MY'],
  'Province': ['CA', 'CN', 'ZA', 'ES', 'IT', 'NL', 'BE', 'PH', 'TH', 'VN', 'ID', 'KR'],
  'Region': ['FR', 'CH', 'CL', 'PE', 'GR', 'DK', 'NO', 'SE', 'FI'],
  'County': ['GB', 'IE', 'KE', 'LR'],
  'Prefecture': ['JP'],
  'Land': ['DE', 'AT'],
  'Emirate': ['AE'],
  'Governorate': ['EG', 'IQ', 'JO', 'SY', 'YE', 'BH', 'KW', 'OM', 'QA'],
  'Department': ['CO', 'PY', 'UY', 'BO', 'GT', 'HN', 'NI', 'PA', 'SV'],
  'District': ['CH', 'PT', 'LK', 'BD'],
  'State/Province': ['PK', 'BD'], // Some countries use both terms
}

export const EXCLUDED_ERROR_MESSAGES = [
  'An active subscription already exists',
  'no account found for',
  'This link has expired',
  'This link is not valid',
  'Failed to create fulfillment policy',  
  'Failed to create return policy',
  'Failed to create payment policy',
]

export const FIELDS_NAMES_BY_CONNECTION = {
  ebay: {
    category: 'ebay_category',
    listOfCategories: EBAY_CATEGORIES,
    listingType: 'listing_type',
    acceptOffers: 'accept_offers',
  },
  'ebay-direct': {
    category: 'ebay_category',
    listOfCategories: EBAY_CATEGORIES,
    listingType: 'listing_type',
    acceptOffers: 'accept_offers',
  },
  whatnot: {
    category: 'whatnot_category_id',
    listOfCategories: WHATNOT_CATEGORIES,
    listingType: 'whatnot_listing_type',
    acceptOffers: 'whatnot_accept_offers'
  },
  shopify: {
    listingType: 'listing_type',
  },
}

// Connection key → the store list holding that connection's templates. Keys
// match `DEFAULT_TEMPLATE_PER_CONNECTION_TYPE`, so the two can be walked
// together (`ConnectionStore.ensureDefaultTemplatesSelected`).
export const CONNECTION_LISTING_TEMPLATES_NAMES_PER_CONNECTION = {
  ebay: 'listingTemplates',
  'ebay-direct': 'marketplaceListingTemplates',
  whatnot: 'whatnotListingTemplates',
  collx: 'collxListingTemplates',
  shopify: 'shopifyListingTemplates',
}

export const DEFAULT_TEMPLATE_PER_CONNECTION_TYPE = {
  ebay: { ...DEFAULT_TEMPLATE },
  'ebay-direct': { ...DEFAULT_TEMPLATE },
  whatnot: { ...DEFAULT_TEMPLATE },
  collx: { ...DEFAULT_TEMPLATE },
  shopify: { ...DEFAULT_TEMPLATE },
}

export const CONNECTION_SETTINGS_LISTING_TEMPLATES_PATHS = {
  ebay: '/connections/ebay/marketplace-templates',
  'ebay-direct': '/connections/ebay/marketplace-templates',
  whatnot: '/connections/whatnot/marketplace-templates',
  collx: '/connections/collx/connection-settings',
  shopify: '/connections/shopify/export-settings',
}

export const CONNECTION_SETTINGS_PATHS = {
  ebay: '/connections/ebay/connect',
  'ebay-direct': '/connections/ebay/connect',
  whatnot: '/connections/whatnot/connect',
  collx: '/connections/collx/account-connection',
  shopify: '/connections/shopify/connect',
}

export const TAGS_PROPS = {
  label: 'Add Tags',
  dataField: 'tags',
  addBtnLabel: 'Tag',
  description: 'Select which Card Dealer Pro Tags you want to send to use as Shopify Tags'
}

export const METAFIELDS_PROPS = {
  label: 'Metafield Mapping',
  dataField: 'metafields',
  addBtnLabel: 'Field',
  description: 'Manage how your existing Shopify metafields map to CDP fields. To map to existing fields, enter your Shopify metafield exactly as it exists in Shopify. Click Add Field to create a new Shopify metafield.'
}

/**
 * Shopify default inventory location.
 *
 * the warning is the whole point of the
 * feature, so it lives here rather than being paraphrased in a template.
 */
export const SHOPIFY_LOCATION_PROPS = {
  label: 'Shopify Location',
  readOnlyLabel: 'Shopify Locations',
  addBtnLabel: 'Location',
  rowLabel: 'Default Location',
  columnLabel: 'SHOPIFY LOCATIONS',
  description: "Choose which Shopify location your Card Dealer Pro inventory lives in. Cards you list will be added to this location, and sales at this location sync back to Card Dealer Pro. If you skip this, we'll use your store's default Shopify location.",
}

/**
 * Shown when the locations call SUCCEEDS but returns nothing — the connected
 * store has no locations we can list into. Distinct from a failed call, which
 * says nothing at all rather than blaming the user's store.
 */
export const SHOPIFY_LOCATION_EMPTY = {
  title: 'No Shopify locations found',
  description: "We couldn't find any locations on your connected Shopify store. Add a location in Shopify, then refresh — until then, Card Dealer Pro lists to your store's default location.",
  actionLabel: 'Refresh',
}

export const SHOPIFY_LOCATION_WARNING = {
  title: "Choose carefully — don't change this later",
  body: [
    "Keep this location the same in both Card Dealer Pro and Shopify. If it changes in either place, sales stop syncing: sold cards won't be delisted, and quantities won't go up or down correctly.",
    'To move to a different location, end all your Card Dealer Pro listings in Shopify first, then relist.',
  ],
}


